/* eslint-disable react/jsx-no-bind */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loading from '../common/Loading.js';
import ErrorMessage from '../common/ErrorMessage.js';
import ToastrService from '../../services/toastrService';
import urls from '../../constants/urls';
import * as imageUtils from '../../utils/imageUtils';
import ReactCrop, { makeAspectCrop } from 'react-image-crop';
import MaterialInput from '../common/MaterialInput.js';
import swal from 'sweetalert';
import * as urlUtils from '../../utils/urlUtils';

class EditLookAtMe extends React.Component {
    constructor(props, context) {
        super(props, context);      
        this.initialise = this.initialise.bind(this);
        this.editImage = this.editImage.bind(this);
        this.removeImage = this.removeImage.bind(this);
        this.uploadImage = this.uploadImage.bind(this);
        this.onFileChange = this.onFileChange.bind(this);
        this.showUpload = this.showUpload.bind(this);
        this.updateImage = this.updateImage.bind(this);   
        this.closeEditImage = this.closeEditImage.bind(this);
        this.imageCropping = this.imageCropping.bind(this);
        this.onImageLoaded = this.onImageLoaded.bind(this);
        this.updateSelectedImageField = this.updateSelectedImageField.bind(this);
        this.showNeedImage = this.showNeedImage.bind(this);
        this.state = {
            profile: this.props.profile,
            images: [],
            loadingImages: false,
            showUpload: false,
            uploadingImage: false,
            selectedImage: null,
            imageCropped: false,
            crop: {
                aspect: 1.5,
                width: 100
            }      
        };
     }

     componentWillMount() {
        this.initialise();
     }

    componentDidMount() {  
    }

    componentWillUpdate(nextProps) {
        if(nextProps.profile.ID !== this.props.profile.ID) {
            this.setState({
                profile: nextProps.profile,
                images: [],
                selectedImage: null,
                imageCropped: false,
                crop: {
                    aspect: 1.5,
                    width: 100
                }
            }, this.initialise);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.state.selectedImage && !prevState.selectedImage) {
            window.componentHandler.upgradeDom();  
        }
    }

    initialise(updateProfileImages = false) {
        this.setState({ loadingImages: true, selectedImage: null, error: '', imageCropped: false, uploadingImage: false });
        this.props.actions.getImages(this.state.profile.ID)
            .then(images => {
                this.setState({ loadingImages: false, images });
                if(updateProfileImages) {
                    this.props.actions.updateProfileImages(this.state.profile.ID, images.map(i => {
                        return {
                            ID: i.ID,
                            Name: i.Name,
                            Description: i.Description,
                            Path: i.Path,
                            Featured: i.Featured
                        };
                    }));
                }                
            })
            .catch(error => this.setState({ loadingImages: false }));
    }

    editImage(event, image) {
        event.preventDefault();
        this.setState({ selectedImage: image, error: '', imageCropped: false });
    }

    closeEditImage(event) {
        event.preventDefault();
        this.initialise();
    }

    removeImage(event, image) {
        event.preventDefault();
        if(confirm(`Remove image '${image.Name}' from your LoudUp page?`)) {
            this.props.actions.deleteImage(this.state.profile.ID, image.ID)
                .then(_ => {
                   this.initialise(true);
                })
                .catch(error => {
                    this.setState({ error: 'Sorry, something went wrong, unable to delete image' });
                });
        }
        else {
            return false;
        }
    }

    uploadImage(event) {
        //upload and then send to the edit screen for cropping
        if(this.state.file) {
            this.setState({ uploadingImage: true });
            const file = this.state.file.split(',')[1];
            this.props.actions.uploadImage(this.state.profile.ID, file)
                .then(image => {
                    const images = [...this.state.images].concat(image);   
                    this.setState({ uploadingImage: false, selectedImage: image, images, error: '' });
                    this.props.actions.updateProfileImages(this.state.profile.ID, images.map(i => {
                        return {
                            ID: i.ID,
                            Name: i.Name,
                            Description: i.Description,
                            Path: i.Path,
                            Featured: i.Featured
                        };
                    }));
                })
                .catch(error => {
                    this.setState({ error: error.message, uploadingImage: false });
                });
        }
        else {
            this.setState({error: 'Please select a file to upload'});
        }
        
    }

    showUpload(event) {
        event.preventDefault();
        this.setState({ showUpload: true });
    }

    onFileChange(event) {
        if(event.target.files.length) {
            imageUtils.readImage(event, (upload) => {
                const file = upload.target.result;
                this.setState({ file });
            }, (error) => {
                this.setState({error});
            }, 10);
        }
    }

    updateImage(event) {
        event.preventDefault();
        const image = this.state.selectedImage;
        //only send the image if it changed
        let imageData = null;
        if(this.state.imageCropped) {
            const image = this.imageRef;
            const croppedImage = imageUtils.getCroppedImage(image, this.state.crop);
            imageData = croppedImage.split(',')[1];
            this.setState({ uploadingImage: true });
        }
        this.props.actions.updateImage(this.state.profile.ID, image.ID, image.Name, image.Description, image.Featured, imageData)
            .then(updatedImage => {
                const toastrService = new ToastrService();
                toastrService.showSuccess('', 'The changes have been saved successfully');
                this.initialise(true);
            }) 
            .catch(error => {
                this.setState({ error: error.message, uploadingImage: false });
            });
    }

    imageCropping(crop, pixelCrop) {
        this.setState({ crop, pixelCrop, imageCropped: true });
    }

    onImageLoaded(image) {
        this.imageRef = image;
        const height = image.naturalWidth / 1.5;
        const heightPerc = (height / image.naturalHeight) * 100;
        //centre it vertically
        const y = (image.naturalHeight - height) / 2;
        const yPerc = (y / image.naturalHeight) * 100;
        const crop = {
            width: 100,
            height: heightPerc,
            unit: '%',
            aspect: 1.5,
            x: 0,
            y: yPerc
        };
        
        this.setState({
            crop: crop,
            imageCropped: false
        });
        return false;
    }

    updateSelectedImageField(event) {
        const name = event.target.name;
        const value = event.target.className === 'mdl-checkbox__input' ? event.target.checked : event.target.value;
        const selectedImage = {...this.state.selectedImage};
        selectedImage[name] = value;
        this.setState({ selectedImage });
    }

    showNeedImage(event) {
        event.preventDefault();
        const showLogoRoleTypes = ['Artist', 'Producer', 'Promoter', 'RecordLabel', 'Manager', 'RecordingStudio', 'Venue'];
        swal({
            title: 'Need an image?',
            content: {
                element: 'div',
                attributes: {
                    innerHTML: 'Having a great image makes a huge difference to your profile<p>Get a custom <a href="/go/fiverr-illustration" target="_blank">illustration</a> or <a href="/go/fiverr-portrait" target="_blank">portrait image</a>.' + (showLogoRoleTypes.includes(this.props.profile.RoleType) ? '<br /><br />Prefer a <a href="/go/fiverr-logo" target="_blank">logo</a>?' : '')
                }
            },
            button: 'Ok, got it!'
        });
    }

    render() {
        return (
            !this.state.selectedImage ? 
                <React.Fragment>
                    <p>You can upload up to 5 images</p>
                    <ErrorMessage error={this.state.error} onClose={() => this.setState({ error: null })} />
                    {
                        this.state.images.length < 5 ?
                            <React.Fragment>
                                {
                                    !this.state.showUpload ?
                                        <p>
                                            <a href="#" className="btn-simple transition" onClick={this.showUpload}>Upload new image &#8594;</a>
                                            <br />
                                            <br />
                                            <br />
                                            <a href="#" className="btn btn-primary btn-simple transition" style={{color: '#fff'}} onClick={this.showNeedImage}><strong>Need an image?</strong></a>
                                        </p>
                                        :
                                        <div id="uploadImageHolder">
                                            <p>
                                                <span>Filename:</span>
                                                <input type="file" id="File" name="File" accept="image/*" onChange={this.onFileChange} />
                                            </p>
                                            <br />
                                            <input type="button" onClick={this.uploadImage} value="Upload" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent mdl-button--wide" /> { this.state.uploadingImage ? <Loading /> : null }
                                        </div>
                                }                            
                            </React.Fragment>
                        : null
                    }
                    <div id="imagesHolder">
                    {
                        this.state.images.length ?
                            <div className="images">
                                {
                                    this.state.images.map(image => 
                                        <div key={image.ID} className="imagelink">    
                                            <p>{image.Name || ' '}</p>
                                            <img src={`${urls.USER_IMAGES_BASE_URL}${image.Path}?width=200&quality=80&mode=crop&format=jpg`} title={image.Description} /> 
                                            <div className="ctrlbtns">
                                                <a href="#" className="btn-simple transition" onClick={(e) => this.editImage(e, image)}>Edit</a>
                                                <a href="#" className="btn-simple transition" onClick={(e) => this.removeImage(e, image)}>&times; Remove</a>
                                            </div>       
                                        </div>
                                    )

                                }
                            </div>
                        :
                        <span style={{paddingTop: '15px'}}>{this.state.loadingImages ? <Loading /> : 'No images have been added to your LoudUp page yet'}</span>
                    }
                    </div>
                </React.Fragment>   
            :            
                <div id="editImage" className="form form-block">
                    <a href="#" style={{float:'right'}} onClick={this.closeEditImage}>Close</a>
                    <p style={{fontWeight: 'bold'}}>Edit image</p>
                    <form id="frmEditImage" onSubmit={this.updateImage}>
                        <ErrorMessage error={this.state.error} onClose={() => this.setState({ error: null })} />
                        <div>
                            <p>
                                Crop as needed
                            </p>             
                            <ReactCrop src={`${this.state.selectedImage.Path}?width=480`} minWidth="480" minHeight="320" onImageLoaded={this.onImageLoaded} onChange={this.imageCropping} crop={this.state.crop} />                
                        </div>
                        <div className="clear" />
                        <br />
                        <MaterialInput name="Name" title="Title" value={this.state.selectedImage.Name} onChange={this.updateSelectedImageField} maxLength="30" />
                        <MaterialInput name="Description" value={this.state.selectedImage.Description} onChange={this.updateSelectedImageField} maxLength="300" />
                        { //check if this was the original featured image, if so, don't allow it to be deselected, we can only select a new featured image
                            !this.state.images.find(i => i.ID === this.state.selectedImage.ID).Featured ?
                            <label className="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" htmlFor="Featured" style={{ paddingBottom: '25px' }}>
                                <input type="checkbox" id="Featured" name="Featured" className="mdl-checkbox__input" defaultChecked={this.state.selectedImage.Featured} onChange={this.updateSelectedImageField} />
                                <span className="mdl-checkbox__label">Set as featured image</span>
                            </label>
                            : null
                        }
                        <input type="submit" value="Save" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent mdl-button--wide" /> { this.state.uploadingImage ? <Loading /> : null }
                    </form>
                </div>
                 
        );
    }
}

EditLookAtMe.propTypes = {
    profile: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

export default EditLookAtMe;